import React, { useState } from 'react';
import { Row, Col, Card, Nav, Badge, Container } from 'react-bootstrap';
import ListingActions from 'components/ListingActions';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';

const ListingStatuses = ({
  statuses,
  fields,
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions,
  isAttachingFiles,
}) => {
  const { t } = useTranslation();
  const [all, setAll] = useState(true);

  const colors = ['29e38f', '17d325', 'a09e0c', 'bed91f', 'a30624', '4847b0', '9488b2', 'f25cd5', '13c918', 'df2df5', '17cb85', '47f30c', '8b92ff', 'd8091f', '2c3ba0', '21209d', 'd3a96c', 'f6300b', '623bf0', 'ef04e8', '19f4a9', 'c5576d', 'fff8eb', 'b43300', 'e14316', '81956d', '4109c4', '1e2843'];

  const handleSelect = (status_id) => {
    handleFilterChange({ 
      status_id:status_id!=0?status_id:null
      , page: 1 }, true);
    if (status_id !== 0) {
      setAll(false);
    } else {
      setAll(true);
    }
  };
  let count = 0;
  
  return (
    <>
      <Row>
        <Col>
          <Container className="mb-3">
            <Card.Body className={style.statuses}>
              <Nav
                variant="pills"
                activeKey={stateFilters.status_id?stateFilters.status_id:0}
                onSelect={handleSelect}
              >
                {statuses.map((status, k) => {
                  count += status.count;
                  return (
                    <Nav.Item key={k}>
                      <Nav.Link key={k} eventKey={status.id}>
                        {t(`statuses:${status.name}`)}
                        <Badge variant="light">{status.count}</Badge>
                      </Nav.Link>
                    </Nav.Item>
                  );
                })}
                <Nav.Item>
                  <Nav.Link eventKey={0}>
                    {t('label:all')}
                    <Badge variant="light">{count}</Badge>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Body>
          </Container>
        </Col>
        {/* <Col md="12" className='d-flex flex-wrap justify-content-between'>
          {statuses.map((s, i) => {            
            return <span className='m-badge' style={{background: "#"+colors[i]}}>{s.description}</span>
          })}
        </Col> */}
      </Row>
      <hr />
      <Row className="mt-4">
        <Col>
          <ListingActions
            {...{
              fields,
              data,
              filters,
              stateFilters,
              handleFilterChange,
              actions,
              all,
              isAttachingFiles,
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default ListingStatuses;
